'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        padding: "0px 16px 0px 16px",
        minHeight: "auto",
        boxShadow: `inset 0px -1px 0px 0px ${variables.COLORS.GREYSCALE_0_15}`,
        "&$focused": {
            borderColor: variables.COLORS.MISC_FOCUS_BORDER,
            boxShadow: `inset 0 0 0 2px ${variables.COLORS.MISC_FOCUS_BORDER}`,
            borderRadius: variables.SIZES.BORDER_RADIUS,
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
        },
        "&$expanded": {
            minHeight: "auto",
        },
    },
    content: {
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
};

var MuiAccordionSummary = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiAccordionSummary = MuiAccordionSummary;
exports.light = light;
